export default "__VITE_ASSET__DCKIawmV__";